<template>
    <div class="flex flex-col">
        <button
                class="w-1/3 mx-auto btn is-outlined mt-4 mb-1 px-6 py-2"
                @click="uploading = true"
                v-show="!uploading"
        >
            Aggiungi Immagini
        </button>
        <image-uploader
                :model="model"
                :id="id"
                v-show="uploading"
        >

        </image-uploader>
        <images-visualizer
                :model="model"
                :id="id"
                v-show="!uploading"
                @reloaded="resetManager"
        >

        </images-visualizer>
    </div>
</template>

<script>
    import ImagesVisualizer from "./ImagesVisualizer";
    import ImageUploader from "./ImageUploader";

    export default {
        provide() {
            return {
                imageUploaderState: this.sharedState
            }
        },
        components: {ImageUploader, ImagesVisualizer},
        props: ['model', 'id'],

        data: () => ({
            uploading: false,
            sharedState: {
                uploaded: false
            }
        }),

        methods: {
            resetManager() {
                this.uploading = false;
                this.sharedState.uploaded = false;
            }
        }

    }
</script>

<style scoped>

</style>